import React from 'react';
import { makeStyles } from '@material-ui/styles';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'inline-block',
      fontWeight: 'bold'
    },
    chip: {
      height: 12,
      width: 12,
      borderRadius: '20%',
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: 4
    },
    prod: {
      background: theme.palette.environment.prod
    },
    dev: {
      background: theme.palette.environment.dev
    },
    other: {
      background: theme.palette.environment.other
    }
  };
});

export default function DisplayEnv({ environment }) {
  const classes = useStyles();
  return (
    <>
      <span className={classes.root}>
        <span
          className={classnames(
            classes.chip,
            classes[environment] ? classes[environment] : classes.other
          )}
        />
        {environment}
      </span>{' '}
    </>
  );
}
